<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  /** The title text of a `ComboboxHeader`. */
  const props = defineProps<{
    class?: HTMLAttributes['class']
  }>()
</script>

<template>
  <span
    data-slot="combobox-header-title"
    :class="cn('text-muted-foreground text-xs font-medium', props.class)"
  >
    <slot />
  </span>
</template>
